import { type Observable, take } from 'rxjs';

export function observableToPromise<T>(observable: Observable<T>, signal?: AbortSignal): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    // take(1) ends the subscription after the first value, so a source that emits
    // synchronously never reaches back into `subscription` before it is assigned.
    const subscription = observable.pipe(take(1)).subscribe({ next: resolve, error: reject });

    if (signal) {
      const onAbort = () => {
        subscription.unsubscribe();
        reject(new DOMException('Aborted', 'AbortError'));
      };
      if (signal.aborted) {
        onAbort();
      } else {
        signal.addEventListener('abort', onAbort, { once: true });
      }
    }
  });
}
